import ProjectCards from '../components/ProjectCards';
import { CaseStudyComponent } from '../components/CaseStudyComponent';

export default function BookApp() {
    return (
        <>
            <CaseStudyComponent slug="book-app" />
        </>
    )
}